import React, { FC } from 'react';
import { Modal } from 'antd';
import COButton from '../COButton';
import styles from './RequestProductionRegionModal.module.scss';
import {
  ButtonLabels,
  CreateBrandModalProps,
} from 'enums/CreateBrandModalEnums';
import InputField from '../InputField';
import { Formik, Form } from 'formik';
import ProductsService from 'services/ProductsService/products.service';
import { ReactComponent as MessageIcon } from 'assets/ColorIcons/SVG/group_58673.svg';
import { useParams } from 'react-router-dom';
import { fieldConstants } from './fieldConstant';
import { requestProductionRegionValidationSchema } from './requestProductionRegionValidationSchema';
import { modalCloseIcon } from '../OrganizationModal';
import { CommodityTypes } from 'constants/FarmboxConstants/stage0.constants';

interface RequestProductionRegionModalProps {
  showModalState: boolean;
  ingredientName: string;
  ingredientId: string;
  handleModalCancel: () => void;
  handleModalConfirm: () => void;
  isIngredientId?: boolean;
  isScopeThree?: boolean;
  isFarmbox?: boolean;
  isFeed?: boolean;
}

const {
  INGREDIENT_NAME,
  INGREDIENT_NAME_PLACEHOLDER,
  PACKAGING_NAME_PLACEHOLDER,
  INGREDIENT_ORIGIN_PLACEHOLDER,
  INGREDIENT_ORIGIN,
  THANK_YOU_TEXT,
  SUBMIT,
} = fieldConstants;

const RequestProductionRegionModal: FC<
  RequestProductionRegionModalProps
> = props => {
  const { id: productId } = useParams();

  const {
    showModalState,
    handleModalCancel,
    handleModalConfirm,
    ingredientName,
    ingredientId,
    isIngredientId = true,
    isScopeThree,
    isFarmbox,
    isFeed,
  } = props;
  const { requestIngredient, buttonLoading } = ProductsService();
  const initialValues = {
    name: ingredientName,
    origin: '',
    activity_mapping_id: ingredientId.toString(),
  };

  type RequestProductionRegionData = {
    name: string;
    origin: string;
    activity_mapping_id?: string | undefined;
  };

  const handleFormSubmission = async (values: RequestProductionRegionData) => {
    try {
      if (productId) {
        await requestIngredient({
          ...values,
          material_type: 'production-region',
          ...(isScopeThree
            ? { location_id: productId }
            : isFarmbox
            ? { commodity_id: productId }
            : { product_id: productId }),
          ...(isFarmbox &&
            isFeed && { commodity_type: CommodityTypes.LIVE_STOCK }),
          ...(isFarmbox &&
            !isFeed && { commodity_type: CommodityTypes.AGRICULTURE }),
        });
      }
      handleModalConfirm();
    } catch (error) {}
  };

  return (
    <Modal
      destroyOnClose={true}
      maskClosable={false}
      width={CreateBrandModalProps.MODAL_WIDTH}
      footer={null}
      className={styles.modalContainer}
      open={showModalState}
      closeIcon={modalCloseIcon}
      onCancel={handleModalCancel}
      centered>
      <div className={styles.formContainer}>
        <div className={styles.headerContainer}>
          <MessageIcon />
          <h2>Request new production region</h2>
        </div>

        <Formik
          enableReinitialize
          initialValues={initialValues}
          validationSchema={requestProductionRegionValidationSchema}
          onSubmit={handleFormSubmission}>
          <Form>
            <div className={styles.fieldContainer}>
              <InputField
                name={INGREDIENT_NAME}
                placeholderstring={INGREDIENT_NAME_PLACEHOLDER}
                label={
                  isIngredientId
                    ? INGREDIENT_NAME_PLACEHOLDER
                    : PACKAGING_NAME_PLACEHOLDER
                }
                disabled
              />
            </div>
            <div className={styles.fieldContainer}>
              <InputField
                name={INGREDIENT_ORIGIN}
                placeholderstring={INGREDIENT_ORIGIN_PLACEHOLDER}
                label={INGREDIENT_ORIGIN_PLACEHOLDER}
              />
            </div>

            <h3 className={styles.thankText}>{THANK_YOU_TEXT}</h3>

            <div className={styles.buttonContainer}>
              <COButton submit loading={buttonLoading}>
                {SUBMIT}
              </COButton>
              <COButton secondary onClick={handleModalCancel}>
                {ButtonLabels.CANCEL}
              </COButton>
            </div>
          </Form>
        </Formik>
      </div>
    </Modal>
  );
};

export default RequestProductionRegionModal;
